import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const InsertImageButton = () => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.commands.activateMediaManager()}
         icon={<FaIcon name="image" />}
         title={_js('Insert an image')}
      />
   );
};
